import { gql } from "@apollo/client";

export const GET_ALL_ACTIVITIES = gql`
  query GetAllActivities(
    $take: Int
    $skip: Int
    $inLibrary: Boolean
    $statusView: StatusView
    $cognitiveDomain: CognitiveDomain
    $feature: Feature
  ) {
    voiceMessages(
      data: {
        take: $take
        skip: $skip
        inLibrary: $inLibrary
        statusView: $statusView
        cognitiveDomain: $cognitiveDomain
        feature: $feature
      }
    ) {
      count
      data {
        id
        title
        templateLink
        category
        feature
        focus
        cognitiveDomains
        deletedAt
        createdOn
        difficulty
        recordedBy {
          id
        }
        audioFile {
          id
          durationInSeconds
          filename
          downloadUrl
        }
      }
    }
  }
`;

export const UPLOAD_VOICE_MESSAGE = gql`
  mutation UploadVoiceMessage($file: Upload!, $durationInSeconds: Int!) {
    uploadVoiceMessage(file: $file, durationInSeconds: $durationInSeconds) {
      id
    }
  }
`;

export const GET_DIFFICULTY_ENUMS = gql`
  query GetDifficultyEnums {
    difficultyEnums
  }
`;
